import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import routes from './Routes';
import ApolloServiceProvider from './ApolloServiceProvider';
import ApolloContextProvider from './ApolloContextProvider';

const Root = ({ store, history }) => {
    return (
        <ApolloServiceProvider>
            <Provider store={store}>
                <ApolloContextProvider>
                    <ConnectedRouter
                        history={history}>
                        {routes}
                    </ConnectedRouter>
                </ApolloContextProvider>
            </Provider>
        </ApolloServiceProvider>
    );
};

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default Root;
